<template>
<v-dialog persistent v-model="show" width="500">
  <v-card>
    <v-card-title>
      <span class="headline">フリータイム変更</span>
    </v-card-title>
    <v-card-actions>
      <v-btn :disabled="!valid" @click="changeFreeDays()">変更</v-btn>
      <v-btn @click="show = false">{{ $t('app.buttons.back') }}</v-btn>
    </v-card-actions>
    <v-form ref="form" v-model="valid">
      <v-container fluid>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field clearable :rules="[
                  (v) =>
                    /^[1-9][0-9]?$/.test(v) ||
                    '2桁までの日数を入力してください',
                ]" type="number" label="フリータイム(2桁までの日数を入力してください)" v-model="freeDays"></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() {
    return {
      freeDays: null,
      show: false,
      valid: false,
      shipments: [],
    }
  },
  methods: {
    popup(shipments) {
      this.show = true
      this.shipments = shipments
    },
    changeFreeDays() {
      Promise.all(
        this.shipments.map((s) => {
          return this.$http
            .put(
              `/free-days/change-free-days/${s.shipmentId}?freeDays=${this.freeDays}`
            )
            .then((res) => {
              if (res.data) {
                this.$message(
                  '',
                  'フリータイムが短縮されたので、設定した納入予定日が正常期間を超えたので、コンテナ調整をお願い致します。'
                )
                this.show = false
                this.$emit('load')
                return
              }
              this.$message('', 'SUCCESS')
              this.show = false
              this.$emit('load')
            })
        })
      )
    },
    refreshData() {
      this.show = false
      this.shipment = {}
      this.$emit('load')
    },
  },
  computed: {},
  watch: {},
}
</script>

<style>
</style>
